var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrows / right arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.41849 11.0073L14.7761 3.39836C14.8969 3.27213 15.0407 3.17194 15.1991 3.10357C15.3575 3.0352 15.5274 3 15.699 3C15.8706 3 16.0406 3.0352 16.199 3.10357C16.3574 3.17194 16.5011 3.27213 16.622 3.39836C16.8641 3.65068 17 3.99201 17 4.3478C17 4.70358 16.8641 5.04491 16.622 5.29724L10.1873 12.0308L16.622 18.6971C16.8641 18.9494 17 19.2908 17 19.6465C17 20.0023 16.8641 20.3437 16.622 20.596C16.5016 20.7232 16.358 20.8245 16.1996 20.8938C16.0412 20.9632 15.871 20.9993 15.699 21C15.5271 20.9993 15.3569 20.9632 15.1985 20.8938C15.0401 20.8245 14.8965 20.7232 14.7761 20.596L7.41849 12.987C7.28654 12.8609 7.18124 12.7078 7.10921 12.5375C7.03718 12.3671 7 12.1832 7 11.9972C7 11.8112 7.03718 11.6272 7.10921 11.4569C7.18124 11.2865 7.28654 11.1334 7.41849 11.0073Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron_left.656dfa5ab22d7547ae2966a4a77ab02b.svg";
export { ForwardRef as ReactComponent };